module.exports = __webpack_public_path__ + "static/media/logo_text_1.ef2027a9.png";